import React, { useState, useEffect } from "react";
import "./complaint.css";
import ComplaintDashHeader from "./ComplaintDashHeader";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { getComplaintsDashboardData } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import ComplaintFirstSection from "./ComplaintFirstSection";
import ComplaintSecondSection from "./ComplaintSecondSection";
import DownloadReportModal from "../downloadReport/Modal";
import DateFilter from "../../../components/common/DateFilter";

const ComplaintsDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState("");
  const [amount, setAmount] = useState("");
  const [penalty, setPenalty] = useState("");
  const [showGenerateReport, setShowGenerateReport] = useState(false);

  const [appliedStartDate, setAppliedStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(0, 0, 0, 0));
  });

  const [appliedEndDate, setAppliedEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(23, 59, 59, 999));
  });

  const token = useSelector((store) => store.userReducer.token);

  const fetchComplaintsDashboard = async (token, startDate, endDate) => {
    setIsLoading(true);

    const formattedStart = startDate.toISOString();
    const formattedEnd = endDate.toISOString();

    const response = await getComplaintsDashboardData(
      token,
      formattedStart,
      formattedEnd,
    );

    setCount(response.count);
    setAmount(response.amount);
    setPenalty(response.fees);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchComplaintsDashboard(token, appliedStartDate, appliedEndDate);
  }, [token, appliedStartDate, appliedEndDate]);

  const handleDateChange = (startDate, endDate) => {
    setAppliedStartDate(new Date(startDate));
    setAppliedEndDate(new Date(endDate));
  };

  return (
    <>
      <div className="recon-main-header">
        <ComplaintDashHeader />
      </div>
      <DateFilter onDateChange={handleDateChange} />

      <div className="download-report-recon">
        <div className="">
          <h2>Download Reports</h2>
        </div>
        <div className="download-report-head">
          <button
            className="btn-report-recon"
            onClick={() => setShowGenerateReport(true)}
          >
            Generate Report
          </button>
        </div>
      </div>

      <>
        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={3}
            imageHeight={200}
          />
        ) : (
          <ComplaintFirstSection
            count={count}
            amount={amount}
            penalty={penalty}
          />
        )}

        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={1}
            imageHeight={200}
          />
        ) : (
          <ComplaintSecondSection amount={amount} penalty={penalty} />
        )}
      </>
      {showGenerateReport && (
        <DownloadReportModal onClose={() => setShowGenerateReport(false)} />
      )}
    </>
  );
};

export default ComplaintsDashboard;
